export interface HeroSlide {
  /** Path under /public. Slide 0 MUST equal the static poster src so the
   *  slideshow layer fades in over an identical first frame (no jump, no
   *  second fetch — served from cache). */
  src: string;
  /** i18n key suffix under `hero.slides.*` (kept for future use; the layer
   *  itself is aria-hidden + alt="" so it is not read by screen readers). */
  altKey: string;
}

/** Mobile hero slideshow photos. 1440px webp variants generated in Task 2. */
export const HERO_SLIDES: HeroSlide[] = [
  { src: "/images/complex/complex2-mobile-v3.webp", altKey: "complex" },
  { src: "/images/complex/PoolView-mobile-v3.webp", altKey: "pool" },
  { src: "/images/complex/BeachView-mobile-v3.webp", altKey: "beach" },
  { src: "/images/complex/complex3-mobile-v3.webp", altKey: "park" },
];

/** ms each slide stays before crossfading to the next. */
export const HERO_SLIDE_INTERVAL_MS = 6000;

/** Delay before the slideshow layer mounts. MUST stay >= the desktop video
 *  mount delay (RoomSelection VIDEO_MOUNT_DELAY_MS = 5000) so the slideshow
 *  never enters the DOM inside Lighthouse's LCP observation window — that
 *  invariant is what keeps the 17.4s LCP regression (commit 0a7880d) from
 *  returning. */
export const HERO_MOUNT_DELAY_MS = 5000;

/** Next index in a cyclic sequence. */
export function nextSlide(current: number, total: number): number {
  if (total <= 0) return 0;
  return (current + 1) % total;
}

/** Whether the animated layer should mount: mobile only, never under
 *  prefers-reduced-motion. */
export function shouldMountSlideshow(opts: {
  isMobile: boolean;
  reducedMotion: boolean;
}): boolean {
  return opts.isMobile && !opts.reducedMotion;
}
